<script lang="ts" xmlns="http://www.w3.org/1999/html">
    import type { CartType, Product, CartProduct } from "../model";
    import { getContext, onMount } from "svelte";
    import { api, cart, loader, config } from "../stores";
    import { Link } from "svelte-navigator";
    import Cart_Confirm from "./Cart_Confirm.svelte";
    import PastillePromotion from "../product/PastillePromotion.svelte";
    import InputQuantity from "../components/InputQuantity.svelte";

    type PromoStatus = "inProgress" | "completed" | "TEL";

    export let operationCode: string;
    export let shopId: string;
    export let uid: string;
    export let quantity: number = 0;
    export let cartType: CartType;
    export let price: number = 0;
    export let originePrice: number = 0;
    export let name: string;
    export let size: string;
    export let model: string;
    export let dateEnd: number;
    export let meca: string;
    export let applicablePromoQty: number = 0;
    export let nbLot: number = 0;
    export let x: number = 0;
    export let y: number = 0;

    export let color = "black";
    export let modelRow: "simple" | "standard" = "simple";

    let product: Product;
    let self: CartProduct = {
        quantity: quantity,
        uid: uid,
        cartType: cartType,
        operationCode: operationCode,
        shopId: shopId,
        price: price.toString(),
        originePrice: originePrice.toString(),
        name: name,
        size: size,
        model: model,
        dateEnd: dateEnd,
        meca: meca,
        applicablePromoQty: applicablePromoQty,
        nbLot: nbLot,
        x: x,
        y: y,
    };

    let attentionBannerShow = false;
    let promoCompleted: PromoStatus = "inProgress";
    let promoCompletedQty = 0;
    let qtyOffered = 0;
    let qtyPriceSaved = 0;
    // let applicatedPromoQty = 0;

    let lastQuantity = 0;

    const { open } = getContext("simple-modal");
    let windowWidth = 0; // [pixel]
    const windowBreak = 1024; // [pixel]

    onMount(async () => {
        lastQuantity = self.quantity;
        const loaderId = $loader.show();
        $api.getProduct(uid).then(
            (res) => {
                $loader.hide(loaderId);
                product = res;
                calculePrice();
                $cart.list.subscribe((list) => {
                    const index = list.findIndex((e) => e.uid == uid);
                    if (index >= 0) {
                        applicablePromoQty = list[index].applicablePromoQty;
                        self = list[index];
                        quantity = self.quantity;
                        lastQuantity = quantity;
                        calculePrice();
                    }
                });
            },
            (err) => {
                console.error(err);
                $loader.hide(loaderId);
            }
        );
        $loader.hide(loaderId);
    });

    function calculePrice(): number {
        price = Number(product.price) * quantity;
        let discountQty = Number(product.discountPriceQty); // nb of product discounted
        if (discountQty <= 0) {
            discountQty = 0;
        }
        let priceAmount = 0;
        switch (product.meca) {
            case "meca1": // -X%
                // add discount to price to get price without discount
                product.priceWithoutDiscount = (
                    parseFloat(product.price) +
                    (parseFloat(product.discountAmount) / 100) *
                        parseFloat(product.price)
                ).toString();

                qtyPriceSaved =
                    (parseFloat(product.priceWithoutDiscount) -
                        parseFloat(product.price)) *
                    quantity;
                price = Number(product.price) * quantity;
                promoCompleted = "completed";
                attentionBannerShow = quantity > 0;
                promoCompletedQty = quantity;
                promoCompleted = "completed";
                break;
            case "meca2": // -X€
                // add discount to price to get price without discount
                product.priceWithoutDiscount = (
                    parseFloat(product.price) +
                    parseFloat(product.discountAmount)
                ).toString();

                qtyPriceSaved =
                    (parseFloat(product.priceWithoutDiscount) -
                        parseFloat(product.price)) *
                    quantity;

                price = Number(product.price) * quantity;
                promoCompletedQty = quantity;
                promoCompleted = "completed";
                attentionBannerShow = quantity > 0;
                break;
            case "meca3": // -X% sur le Xe produit
                let unitPrice = parseFloat(product.price); // unit price
                let percent = parseFloat(product.discountAmount); // percent discount
                let unitPriceDiscounted = (percent * unitPrice) / 100; // unit price discounted

                if (quantity > 0 && discountQty > 0) {
                    nbLot = Math.floor(quantity / discountQty); // nb lot
                } else {
                    nbLot = 0;
                }

                if (applicablePromoQty == -1 || nbLot !== 0) {
                    applicablePromoQty = nbLot;
                }

                attentionBannerShow =
                    applicablePromoQty > 0 || applicablePromoQty == -1;
                price = price - applicablePromoQty * unitPriceDiscounted;

                promoCompletedQty = discountQty * nbLot;
                promoCompleted =
                    quantity >= promoCompletedQty ? "completed" : "inProgress";
                qtyPriceSaved = applicablePromoQty * unitPriceDiscounted;
                break;
            default:
                attentionBannerShow = false;
                promoCompletedQty = 0;
                qtyOffered = 0;
                qtyPriceSaved = 0;
                promoCompleted = "inProgress";
        }
        price = Math.round(price * 100) / 100;
        self.price = price.toFixed(2).toString();
        self.nbLot = nbLot;
        self.applicablePromoQty = applicablePromoQty;
        self.x = x;
        self.y = y;
        return price;
    }

    function getNewQuantity(e) {
        if (e.detail == null) return;

        quantity = e.detail;
        updateQte();
    }

    function updateQte() {
        let diff = quantity - lastQuantity;
        lastQuantity = quantity;

        if (quantity <= 0) {
            onRemoveProduct();
            return;
        }

        calculePrice();
        if (diff > 0) {
            $cart.add(self, diff, cartType);
        } else if (diff < 0) {
            $cart.remove(self, diff * -1);
        }
    }

    function onRemoveProduct() {
        if (quantity <= 0) {
            // responsive
            let styleWindowWrap = {
                margin: "auto",
                width: "100%",
                height: "auto",
                top: "auto",
            };
            let styleWindow = {
                margin: "auto",
                width: "40%",
                height: "auto",
                top: "auto",
            };
            if (windowWidth <= windowBreak) {
                styleWindowWrap = {
                    margin: "0",
                    width: "100%",
                    height: "auto",
                    top: "auto",
                };
                styleWindow = {
                    margin: "0",
                    width: "100%",
                    height: "auto",
                    top: "auto",
                };
            }
            // open the modal
            open(
                Cart_Confirm,
                { onOkay, onCancel, name: product.name },
                {
                    closeOnOuterClick: false,
                    closeOnEsc: false,
                    closeButton: false,
                    styleWindowWrap,
                    styleWindow,
                }
            );
        } else {
            $cart.remove(self);
        }
    }

    const onOkay = async () => {
        $cart.remove(self);
    };

    const onCancel = async () => {
        quantity = 1;
        lastQuantity = 1;
        updateQte();
    };

    function onDeleteProduct() {
        $cart.remove(self, quantity);
    }

    function changeCartType(target: CartType) {
        $cart.setType(self, target);
    }

    function setSize(e) {
        let txt = e.target.value;
        $cart.setSize(self, txt);
    }

    function setModel(e) {
        let txt = e.target.value;
        $cart.setModel(self, txt);
    }
</script>

<svelte:window bind:outerWidth={windowWidth} />

{#if product != null}
    <!-- ================================ DESKTOP VERSION =============================================== -->
    <div
        id="desktop-version"
        class="{attentionBannerShow ? 'showBanner' : ''} {promoCompleted}"
        class:row-standard={modelRow === "standard"}
        class:row-simple={modelRow === "simple"}
    >
        <Link
            class="col-product"
            to="/catalog/{$api.getOperationCode() +
                '/' +
                $api.getShopId() +
                '/products/' +
                product.uid}"
        >
            <div class="col-product-content">
                <div class="product-img">
                    <img
                        src={product.images.length > 0
                            ? product.images[0] + "?g=100x100"
                            : ""}
                        alt="Chargement de l'image:{product.name}"
                    />
                </div>
                <div class="product-data">
                    <h5 class="text-black">{product.brand}</h5>
                    <p id="product-title" class="text-black">{product.name}</p>
                </div>
            </div>
        </Link>
        <div class="col-price">
            <div class="final-price txt-{color}">
                {Number(product.price).toFixed(2).replace(".", ",")}
                <sup>€</sup><br />
            </div>
            {#if product.priceWithoutDiscount !== "" && product.priceWithoutDiscount !== product.price}
                <div class="initial-price">
                    Prix initial: {Number(product.priceWithoutDiscount)
                        .toFixed(2)
                        .replace(".", ",")} <sup>€</sup>
                </div>
            {/if}
        </div>
        <div class="col-promo">
            <PastillePromotion {product} />
        </div>
        <div class="col-quantity">
            <div class="quantity">
                <div class="quantity-viewer">
                    <InputQuantity
                        {quantity}
                        on:update-quantity={getNewQuantity}
                    />

                    {#if self.price !== product.price || quantity > 1}
                        <div class="quantity-total-price">
                            <span>
                                {Number(self.price)
                                    .toFixed(2)
                                    .replace(".", ",")} <sup>€</sup>
                            </span>
                        </div>
                    {/if}

                    {#if cartType && cartType === "shoppingList" && product.isCC && $config.config.ClickAndCollect}
                        <div
                            class="quantity-change-type txt-orange"
                            on:click={() => changeCartType("clickCollect")}
                        >
                            Réserver en <br /> Click & Collect
                        </div>
                    {/if}
                    {#if cartType && cartType === "clickCollect"}
                        <div
                            class="quantity-change-type txt-blue"
                            on:click={() => changeCartType("shoppingList")}
                        >
                            Mettre dans le <br /> mémo courses
                        </div>
                    {/if}
                </div>
                <div class="quantity-delete">
                    <span class="icon icon-trash" on:click={onDeleteProduct}>
                        <i class="fas fa-trash-alt" />
                    </span>
                </div>
            </div>
        </div>
    </div>
    <!-- ================================ MOBILE VERSION =============================================== -->
    <div
        id="mobile-version"
        class:row-standard={modelRow === "standard"}
        class:row-simple={modelRow === "simple"}
    >
        <div id="photo">
            <Link
                to="/catalog/{$api.getOperationCode() +
                    '/' +
                    $api.getShopId() +
                    '/products/' +
                    product.uid}"
                style="width: 100%;"
            >
                <img
                    src={product.images.length > 0 ? product.images[0] : ""}
                    alt="Chargement de l'image:{product.name}"
                />
            </Link>
        </div>
        <div id="data" class="">
            <div id="data-header">
                <div id="data-header-title">
                    <h5>{product.brand}</h5>
                    <p id="product-title">{product.name}</p>
                </div>
            </div>
            <div id="data-action">
                <div id="data-action-price" class="">
                    <div class="final-price txt-{color}">
                        {Number(product.price).toFixed(2).replace(".", ",")}
                        <sup>€</sup><br />
                    </div>
                    {#if product.priceWithoutDiscount !== "" && product.priceWithoutDiscount !== product.price}
                        <div class="initial-price">
                            Au lieu de {Number(product.priceWithoutDiscount)
                                .toFixed(2)
                                .replace(".", ",")} <sup>€</sup>
                        </div>
                    {/if}
                </div>
                <div id="data-action-quantity" class="">
                    <div class="quantity-handler">
                        <div class="input-qte">
                            <label for="qte"> Qté: </label>
                            <input
                                type="number"
                                bind:value={quantity}
                                on:change={() => console.log("coucou")}
                            />
                            <div class="change-qte-buttons">
                                <span
                                    class="icon is-clickable"
                                    on:click={() => onAddProduct()}
                                >
                                    <i class="fas fa-chevron-up" />
                                </span>
                                <span
                                    class="icon is-clickable"
                                    on:click={() => onRemoveProduct(-1)}
                                >
                                    <i class="fas fa-chevron-down" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- {#if quantity > 1}
                        <div class="quantity-total-price">
                            <span>
                                {(price * quantity).toFixed(2).replace('.', ',')} <sup>€</sup>
                            </span>
                        </div>
                    {/if} -->
                </div>
                <!-- <div id="data-action-delete" class="">
                    <span class="icon icon-trash" on:click={onDeleteProduct}>
                        <i class="trash is-{color}"></i>
                    </span>
                </div> -->
            </div>
            <div id="data-switch">
                {#if cartType && cartType === "shoppingList" && product.isCC && $config.config.ClickAndCollect}
                    <div
                        class="quantity-change-type txt-orange"
                        on:click={() => changeCartType("clickCollect")}
                    >
                        Réserver en Click & Collect
                    </div>
                {/if}
                {#if cartType && cartType === "clickCollect"}
                    <div
                        class="quantity-change-type txt-blue"
                        on:click={() => changeCartType("shoppingList")}
                    >
                        Mettre dans le mémo courses
                    </div>
                {/if}
            </div>
        </div>
    </div>

    {#if attentionBannerShow}
        <div id="attention-banner">
            {#if promoCompletedQty - quantity > 0}
                Ajoutez encore {promoCompletedQty - quantity} produit{promoCompletedQty -
                    quantity >
                1
                    ? "s"
                    : ""} pour profiter de l'offre
            {/if}
            {#if qtyOffered > 0}
                {qtyOffered} produit{qtyOffered > 1 ? "s" : ""} offert{qtyOffered >
                1
                    ? "s"
                    : ""} !
            {/if}
            {#if qtyPriceSaved > 0}
                {#if promoCompleted === "TEL"}
                    {qtyPriceSaved.toFixed(2).replace(".", ",")}<sup>€</sup> sur
                    votre carte !
                {:else}
                    {qtyPriceSaved.toFixed(2).replace(".", ",")}<sup>€</sup> économisés!
                {/if}
            {/if}
        </div>
    {/if}
{/if}

<style lang="scss">
    @import "../styles/variables";

    .text-black {
        color: black !important;
    }

    .input-qte {
        display: flex;
        flex-direction: row;
        width: 100%;
        gap: 10px;
        align-items: center;
        input {
            width: 50px;
        }
        .change-qte-buttons {
            display: flex;
            flex-direction: column;
        }
    }

    h5 {
        font-size: 15px;
        line-height: 18px;
        font-weight: bold;
    }

    .border {
        border: 1px black solid;
    }

    .TEL-banner {
        background-color: $yellow-TEL !important;
        color: $dark-blue !important;
    }

    #attention-banner {
        padding: 0.3em 2em;
        background-color: $dark-blue;
        color: white;
        border-radius: 10px;
        width: fit-content;
        float: right;
        margin: 0 8px;
        margin-bottom: 5px;
        text-align: center;
    }

    #mobile-version {
        display: none;
    }

    #desktop-version {
        padding: 0 0.5em;
        float: left;
        .col-product {
            .col-product-content {
                display: flex;
                transition: 0.3s ease;
                align-items: center;
                &:hover {
                    transition: 0.3s ease;
                    background-color: $grey-light;
                }
                .product-img {
                    text-align: center;
                    img {
                        width: 100px;
                        height: 100px;
                        object-fit: contain;
                    }
                }
                .product-data {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding-left: 10px;
                    #product-title {
                        text-transform: uppercase;
                        font-size: 0.9em !important;
                        font-family: "Quicksand", sans-serif !important;
                        font-weight: 500;
                    }
                }
            }
        }

        .col-size {
            input {
                font-size: 14px;
                line-height: 16px;
                font-weight: normal;
                border: none;
                border-bottom: solid 1px #999999;
                outline: none;
                width: 90%;
            }
        }

        .col-model {
            input {
                font-size: 14px;
                line-height: 16px;
                font-weight: normal;
                border: none;
                border-bottom: solid 1px #999999;
                width: 90%;
                outline: none;
            }
        }

        .col-price {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .final-price {
                font-family: "Diagramm Bold";
                font-size: 30px;
                letter-spacing: -1px;
            }
            .initial-price {
                font-size: 13px;
                line-height: 20px;
                letter-spacing: 0.3px;
                color: #1a1a1a;
                font-weight: normal;
            }
        }

        .col-promo {
            align-items: center;
            padding-top: 15px;
        }

        .col-quantity {
            display: flex;
            flex-direction: row;
            padding: unset;
            border-radius: unset;
            align-items: center;
            .quantity {
                display: flex;
                // flex-direction: row;
                gap: 5px;
                .quantity-handler {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: unset;
                    border-radius: unset;
                }
                .quantity-total-price {
                    display: flex;
                    justify-content: center;
                    color: $dark-blue;

                    span {
                        font-family: "Diagram Bold";
                    }
                }
                .quantity-change-type {
                    font-size: 13px;
                    text-decoration: underline;
                    text-align: center;
                    cursor: pointer;
                }
                .icon-trash {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    transition: 0.3s ease;
                    color: black;
                    border-radius: 10px;
                    &:hover {
                        transition: 0.3s ease;
                        color: $light-white;
                        background-color: black;
                    }
                }
            }
        }
    }

    @media (max-width: $mobile-breakpoint) {
        #desktop-version {
            display: none;
        }

        .row-standard {
            #data-size {
                display: flex;
            }
            #data-model {
                display: flex;
            }
        }
        .row-simple {
            #data-size {
                display: none;
            }
            #data-model {
                display: none;
            }
        }

        #mobile-version {
            display: flex;
            align-items: center;
            position: relative;
            #photo {
                text-align: center;
                width: 33.33%;
                height: 125px;
                img {
                    object-fit: contain;
                    max-width: 125px;
                    max-height: 125px;
                }
            }
            .pastille {
                position: absolute;
                left: 15%;
                top: -15px;
                transform: scale(0.65);
            }
            #data {
                width: 66.66%;
                height: 150px;
                padding-left: 5px;
                padding-right: 10px;
                #data-header {
                    display: flex;
                    align-items: center;
                    #data-header-title {
                        width: 100%;
                        #product-title {
                            text-transform: uppercase;
                            font-size: 0.9em !important;
                            font-family: "Quicksand", sans-serif !important;
                            font-weight: 500;
                        }
                    }
                }
                #data-size {
                    align-items: end;
                    input {
                        width: 90%;
                        font-weight: normal;
                        border: none;
                        border-bottom: solid 1px #999999;
                        outline: none;
                    }
                    .before-input {
                        width: 50%;
                    }
                }
                #data-model {
                    align-items: end;
                    input {
                        width: 90%;
                        font-weight: normal;
                        border: none;
                        border-bottom: solid 1px #999999;
                        outline: none;
                    }
                    .before-input {
                        width: 50%;
                    }
                }
                #data-action {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 5px;
                    #data-action-price {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        text-align: center;
                        width: 50%;
                        .final-price {
                            font-family: "Diagramm Bold";
                            font-size: 1.3em;
                            letter-spacing: -1px;
                        }
                        .initial-price {
                            font-size: 13px;
                            font-size: 0.8em;
                            letter-spacing: 0.3px;
                            color: #1a1a1a;
                            font-weight: normal;
                        }
                    }
                    #data-action-quantity {
                        .quantity-handler {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            padding: unset;
                            border-radius: unset;
                            transform: scale(0.85);
                            .icon-minus {
                                width: 30px;
                                border-top-left-radius: 213144px;
                                border-bottom-left-radius: 213144px;
                                text-align: end;
                                display: inline-block;
                                height: 40px;
                                padding: 5px;
                                cursor: pointer;
                            }
                            .icon-plus {
                                width: 30px;
                                border-top-right-radius: 213144px;
                                border-bottom-right-radius: 213144px;
                                text-align: end;
                                display: inline-block;
                                height: 40px;
                                padding: 5px;
                                cursor: pointer;
                            }
                            .quantity-text {
                                color: #ffffff;
                                font-size: 22px;
                                text-align: center;
                                height: 40px;
                                width: 40px;
                                padding: 5px;
                            }
                        }
                        .quantity-total-price {
                            display: flex;
                            justify-content: center;
                            color: $dark-blue;
                            span {
                                font-family: "Diagram Bold";
                            }
                        }
                    }
                    #data-action-delete {
                        .icon-trash {
                            cursor: pointer;
                            width: 40px;
                            height: 40px;
                            border-radius: 213144px;
                            background-color: $grey-light;
                            transition: 0.3s ease;
                            padding: 6px;
                            margin-left: 10px;
                            &:hover {
                                background-color: $grey-darken;
                            }
                        }
                    }
                }
                #data-switch {
                    .quantity-change-type {
                        margin-top: 5px;
                        padding: 5px 0;
                        text-decoration: underline;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
        }

        #attention-banner {
            margin-top: 1em;
            padding: 0.3em 1em;
            font-size: 0.9em;
            width: 95%;
            float: initial;
            margin: auto;
        }
    }
</style>
